import type { Timestamp } from "../../google/protobuf/timestamp.types";
import { Reader, Writer } from "protobufjs/minimal";
import type { Long } from "protoc-gen-ts";

export const createBaseTimestamp = (): Timestamp => {
  return {
    seconds: 0,
    nanos: 0,
  };
};

export const decodeTimestamp = (reader: Reader, length: number): Timestamp => {
  const end = reader.pos + length;
  const message = createBaseTimestamp();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.seconds = (reader.int64() as Long).toNumber();

        break;
      case 2:
        message.nanos = reader.int32();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeTimestamp = (writer: Writer, message: Timestamp): Writer => {
  writer.uint32(8).int64(message.seconds);
  writer.uint32(16).int32(message.nanos);

  return writer;
};
